import React, { Suspense } from 'react';
import { Route, Switch } from "react-router-dom";
import Auth from "../hoc/auth";
import AuthRedirect from "../hoc/authRedirect";
// pages for this product
import LandingPage from "./views/LandingPage/LandingPage.js";
import LoginPage from "./views/LoginPage/LoginPage.js";
import UsersPage from "./views/Users/UsersPage.js";
import UserPage from "./views/User/UserPage.js";
import NavBar from "./views/NavBar/NavBar";
import SchoolsPage from "./views/SysAdmin/SchoolsPage"
import MessagePage from "./views/SysAdmin/MessagePage"
import AddSchoolPage from "./views/SysAdmin/AddSchoolPage"

//null   Anyone Can go inside
//true   only logged in user can go inside
//false  logged in user can't go inside

function App() {
  return (
    <Suspense fallback={(<div>Loading...</div>)}>
      <NavBar />
      <div style={{ minHeight: 'calc(100vh - 80px)' }}>
        <Switch>
          <Route exact path="/" component={AuthRedirect(LandingPage, true, 3)} />
          <Route exact path="/login" component={Auth(LoginPage, false)} />

          <Route exact path="/sysadmin/create" component={Auth(AddSchoolPage, true, 3)} />
          <Route exact path="/sysadmin/schools" component={Auth(SchoolsPage, true, 3)} />
          <Route exact path="/sysadmin/schools/:id" component={Auth(UsersPage, true, 3)} />
          <Route exact path="/sysadmin/schools/:id/user/:id" component={Auth(UserPage, true, 3)} />
          <Route exact path="/sysadmin/message/:id" component={Auth(MessagePage, true, 3)} />
        </Switch>
      </div>
    </Suspense>
  );
}

export default App;
